import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useAuthContext } from "../backend/UseAuth";
import { useSignup } from '../backend/Register'
import { getDoc, collection, doc, getFirestore } from "firebase/firestore";
import { useState } from "react";
export default function Repository() {

    const db = getFirestore();
    const { user } = useAuthContext()
    const { logout } = useSignup()
    const handleSubmit = (e) => {
        logout()
    }
    const [Alldocs, setAlldocs] = useState([]);
    const [singleDoc, setSingledoc] = useState([]);

    useEffect(() => {

        getDoc(doc(db, "users", user.uid)).then(docSnap => {
            if (docSnap.exists()) {
                setSingledoc(docSnap.data());
            } else {
                console.log("No such document!");
            }
        })
    }, [])

    return (
        <React.Fragment>

            <div class="overlay"></div>

            <div class="main-body-wrapper d-flex">

                <div class="sidebar-wrapper bg--accent">
                    <div class="sidebar-inner">
                        <ul class="sidebar-menu">
                            <li className="sidebar-menu-item">
                                {
                                    <Link to="/contributions" className="sidebar-menu-link"><img src="assets/images/icon/menu1.png" alt="icon" />
                                    </Link>
                                }
                            </li>
                            <li className="sidebar-menu-item">
                                {
                                    <Link to="/tests" className="sidebar-menu-link"><img src="assets/images/icon/menu2.png" alt="icon" />
                                    </Link>
                                }
                            </li>
                            <li className="sidebar-menu-item">
                                {
                                    <Link to="/domain" className="sidebar-menu-link"> <img src="assets/images/icon/menu3.png" alt="icon" />
                                    </Link>
                                }
                            </li>
                            <li className="sidebar-menu-item">
                                {
                                    <Link to="/visualization" className="sidebar-menu-link"> <img src="assets/images/icon/menu4.png" alt="icon" />
                                    </Link>
                                }
                            </li>
                            <li className="sidebar-menu-item">
                                {
                                    <Link to="/lists" className="sidebar-menu-link"> <img src="assets/images/icon/menu5.png" alt="icon" />
                                    </Link>
                                }
                            </li>
                            <li className="sidebar-menu-item">
                                {
                                    <Link to="/profile" className="sidebar-menu-link"> <img src="assets/images/icon/menu6.png" alt="icon" />
                                    </Link>
                                }
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="main-content">
                    <div class="main-content-inner">

                        <div class="top-menu-wrapper bg-white">
                            <div class="top-menu-inner d-flex flex-wrap gap-2 justify-content-between">
                                <div class="d-sm-block">
                                    <div class="sidebar-toggler fs--20px d-md-none"><i class="fas fa-bars"></i></div>
                                </div>
                                <a href="contributions.html" class="logo"><img src="assets/images/logo.png" alt="logo" /></a>
                                <ul class="top-menu d-flex flex-wrap gap-3">
                                    <li class="top-menu-item">
                                        <a href="javascript:void(0)" class="top-menu-link"><i class="fas fa-bell"></i></a>
                                        <div class="dropdown-wrapper">
                                            <div class="dropdown-inner">
                                                <div class="dropdown-header">
                                                    <div class="d-flex flex-wrap justify-content-between pb-2">
                                                        <h6>Notifications</h6>
                                                        <span>Mark all as read</span>
                                                    </div>
                                                    <ul class="notification">
                                                        <li class="notification-item">
                                                            <div class="d-flex gap-3">
                                                                <div class="notification-item__thumb">
                                                                    <i class="fas fa-user"></i>
                                                                </div>
                                                                <div class="notification-item__content">
                                                                    <h6 class="notification-item__content-name">JSmith1</h6>
                                                                    <p>has contributed</p>
                                                                </div>
                                                            </div>
                                                            <p class="fs--12px">1 min ago</p>
                                                        </li>
                                                        <li class="notification-item">
                                                            <div class="d-flex gap-3">
                                                                <div class="notification-item__thumb">
                                                                    <i class="fas fa-user"></i>
                                                                </div>
                                                                <div class="notification-item__content">
                                                                    <h6 class="notification-item__content-name">JSmith1</h6>
                                                                    <p>has contributed</p>
                                                                </div>
                                                            </div>
                                                            <p class="fs--12px">1 min ago</p>
                                                        </li>
                                                        <li class="notification-item">
                                                            <div class="d-flex gap-3">
                                                                <div class="notification-item__thumb">
                                                                    <i class="fas fa-user"></i>
                                                                </div>
                                                                <div class="notification-item__content">
                                                                    <h6 class="notification-item__content-name">JSmith1</h6>
                                                                    <p>has contributed</p>
                                                                </div>
                                                            </div>
                                                            <p class="fs--12px">1 min ago</p>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li class="top-menu-item">
                                        <a href="javascript:void(0)" class="top-menu-link"><i class="fas fa-user"></i></a>
                                        <div class="dropdown-wrapper">
                                            <div class="dropdown-inner">
                                                <ul class="notification">
                                                    <li class="notification-item border-0">
                                                        <div class="d-flex gap-3">
                                                            <div class="notification-item__thumb">
                                                                <i class="fas fa-user"></i>
                                                            </div>
                                                            <div class="notification-item__content">
                                                            {
                                                                    singleDoc.firstname && <h6 className="notification-item__content-name">
                                                                        {singleDoc.firstname + " " + singleDoc.lastname}
                                                                    </h6>
                                                                }
                                                                <p>Admin</p>
                                                                {
                                                                    <Link to="/profile" className="mt-3 d-block fs--14px fw-semibold">Edit Profile
                                                                    </Link>
                                                                }
                                                                {
                                                                    <Link to="/" onClick={handleSubmit} className="mt-1 d-block fs--14px fw-semibold text--danger">  Log Out
                                                                    </Link>
                                                                }
                                                            </div>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div class="main-content-inner-inner">
                            <div class="card custom--card">
                                <div class="card-header pb-0 d-flex flex-wrap gap-3 justify-content-between align-items-start">
                                    <div class="card-header__left">
                                        <h4 class="title"><a href="#0" onclick="history.back()" class="back-btn p-3 lh-1"><i class="fas fa-angle-left"></i></a> Lorem Ipsum Repository</h4>
                                        <ul class="nav-tabs nav filter mt-2">
                                            <li class="nav-item"><a href="#all-repo" class="nav-link active" data-bs-toggle="tab">All Repository</a></li>
                                            <li class="nav-item"><a href="#monolingual" class="nav-link" data-bs-toggle="tab">Monolingual</a></li>
                                            <li class="nav-item"><a href="#parallel" class="nav-link" data-bs-toggle="tab">Parallel</a></li>
                                        </ul>
                                    </div>
                                    <button class="btn btn--success" data-bs-toggle="modal" data-bs-target="#addRepositoryModal">Add Repository</button>
                                </div>
                                <div class="card-body">
                                    <div class="d-flex flex-wrap justify-content-between gap-3 mb-4">
                                        <div class="search-wrapper">
                                            <form action="">
                                                <div class="form-group">
                                                    <input type="text" class="form-control form--control ps-5" />
                                                    <button class="btn fs--18px border-0 btn--icon" type="submit"><i class="fas fa-search"></i></button>
                                                </div>
                                            </form>
                                        </div>
                                        <div class="d-flex flex-wrap gap-3">
                                            <select>
                                                <option value="">Filter by</option>
                                                <option value="">Upper to Low</option>
                                                <option value="">Lower to Upper</option>
                                            </select>
                                            <select>
                                                <option value="">Filter by</option>
                                                <option value="">Upper to Low</option>
                                                <option value="">Lower to Upper</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="tab-content">
                                        <div class="tab-pane show fade active" id="all-repo">
                                            <table class="table table--responsive--xl">
                                                <thead>
                                                    <tr>
                                                        <th>Language</th>
                                                        <th>Sentence</th>
                                                        <th>Language</th>
                                                        <th>Sentence</th>
                                                        <th>Stuff</th>
                                                        <th>Edit</th>
                                                        <th>Delete</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td data-label="Language">Filipino</td>
                                                        <td data-label="Sentence">Lorem ipsum dolor sit amet</td>
                                                        <td data-label="Language">Cebuano</td>
                                                        <td data-label="Sentence">Lorem ipsum dolor sit amet</td>
                                                        <td data-label="Staff">Admin1</td>
                                                        <td data-label="Edit"><button class="btn btn--warning btn--icon"><i class="fas fa-pen"></i></button></td>
                                                        <td data-label="Delete"><button class="btn btn--danger btn--icon remove-item"><i class="fas fa-trash"></i></button></td>
                                                    </tr>
                                                    <tr>
                                                        <td data-label="Language">Filipino</td>
                                                        <td data-label="Sentence">Lorem ipsum dolor sit amet</td>
                                                        <td data-label="Language">Cebuano</td>
                                                        <td data-label="Sentence">Lorem ipsum dolor sit amet</td>
                                                        <td data-label="Staff">Admin1</td>
                                                        <td data-label="Edit"><button class="btn btn--warning btn--icon"><i class="fas fa-pen"></i></button></td>
                                                        <td data-label="Delete"><button class="btn btn--danger btn--icon remove-item"><i class="fas fa-trash"></i></button></td>
                                                    </tr>
                                                    <tr>
                                                        <td data-label="Language">Filipino</td>
                                                        <td data-label="Sentence">Lorem ipsum dolor sit amet</td>
                                                        <td data-label="Language">Cebuano</td>
                                                        <td data-label="Sentence">Lorem ipsum dolor sit amet</td>
                                                        <td data-label="Staff">Admin1</td>
                                                        <td data-label="Edit"><button class="btn btn--warning btn--icon"><i class="fas fa-pen"></i></button></td>
                                                        <td data-label="Delete"><button class="btn btn--danger btn--icon remove-item"><i class="fas fa-trash"></i></button></td>
                                                    </tr>
                                                    <tr>
                                                        <td data-label="Language">Filipino</td>
                                                        <td data-label="Sentence">Lorem ipsum dolor sit amet</td>
                                                        <td data-label="Language">Cebuano</td>
                                                        <td data-label="Sentence">Lorem ipsum dolor sit amet</td>
                                                        <td data-label="Staff">Admin1</td>
                                                        <td data-label="Edit"><button class="btn btn--warning btn--icon"><i class="fas fa-pen"></i></button></td>
                                                        <td data-label="Delete"><button class="btn btn--danger btn--icon remove-item"><i class="fas fa-trash"></i></button></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div class="tab-pane fade" id="monolingual">
                                            <table class="table table--responsive--xl">
                                                <thead>
                                                    <tr>
                                                        <th>Language</th>
                                                        <th>Sentence</th>
                                                        <th>Stuff</th>
                                                        <th>Edit</th>
                                                        <th>Delete</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td data-label="Language">Filipino</td>
                                                        <td data-label="Sentence">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod </td>
                                                        <td data-label="Staff">Admin1</td>
                                                        <td data-label="Edit"><button class="btn btn--warning btn--icon"><i class="fas fa-pen"></i></button></td>
                                                        <td data-label="Delete"><button class="btn btn--danger btn--icon remove-item"><i class="fas fa-trash"></i></button></td>
                                                    </tr>
                                                    <tr>
                                                        <td data-label="Language">Filipino</td>
                                                        <td data-label="Sentence">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod </td>
                                                        <td data-label="Staff">Admin1</td>
                                                        <td data-label="Edit"><button class="btn btn--warning btn--icon"><i class="fas fa-pen"></i></button></td>
                                                        <td data-label="Delete"><button class="btn btn--danger btn--icon remove-item"><i class="fas fa-trash"></i></button></td>
                                                    </tr>
                                                    <tr>
                                                        <td data-label="Language">Filipino</td>
                                                        <td data-label="Sentence">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod </td>
                                                        <td data-label="Staff">Admin1</td>
                                                        <td data-label="Edit"><button class="btn btn--warning btn--icon"><i class="fas fa-pen"></i></button></td>
                                                        <td data-label="Delete"><button class="btn btn--danger btn--icon remove-item"><i class="fas fa-trash"></i></button></td>
                                                    </tr>
                                                    <tr>
                                                        <td data-label="Language">Filipino</td>
                                                        <td data-label="Sentence">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod </td>
                                                        <td data-label="Staff">Admin1</td>
                                                        <td data-label="Edit"><button class="btn btn--warning btn--icon"><i class="fas fa-pen"></i></button></td>
                                                        <td data-label="Delete"><button class="btn btn--danger btn--icon remove-item"><i class="fas fa-trash"></i></button></td>
                                                    </tr>
                                                    <tr>
                                                        <td data-label="Language">Filipino</td>
                                                        <td data-label="Sentence">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod </td>
                                                        <td data-label="Staff">Admin1</td>
                                                        <td data-label="Edit"><button class="btn btn--warning btn--icon"><i class="fas fa-pen"></i></button></td>
                                                        <td data-label="Delete"><button class="btn btn--danger btn--icon remove-item"><i class="fas fa-trash"></i></button></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div class="tab-pane fade" id="parallel">
                                            <table class="table table--responsive--xl">
                                                <thead>
                                                    <tr>
                                                        <th>Language</th>
                                                        <th>Sentence</th>
                                                        <th>Language</th>
                                                        <th>Sentence</th>
                                                        <th>Stuff</th>
                                                        <th>Edit</th>
                                                        <th>Delete</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td data-label="Language">Filipino</td>
                                                        <td data-label="Sentence">Lorem ipsum dolor sit amet</td>
                                                        <td data-label="Language">Cebuano</td>
                                                        <td data-label="Sentence">Lorem ipsum dolor sit amet</td>
                                                        <td data-label="Staff">Admin1</td>
                                                        <td data-label="Edit"><button class="btn btn--warning btn--icon"><i class="fas fa-pen"></i></button></td>
                                                        <td data-label="Delete"><button class="btn btn--danger btn--icon remove-item"><i class="fas fa-trash"></i></button></td>
                                                    </tr>
                                                    <tr>
                                                        <td data-label="Language">Filipino</td>
                                                        <td data-label="Sentence">Lorem ipsum dolor sit amet</td>
                                                        <td data-label="Language">Cebuano</td>
                                                        <td data-label="Sentence">Lorem ipsum dolor sit amet</td>
                                                        <td data-label="Staff">Admin1</td>
                                                        <td data-label="Edit"><button class="btn btn--warning btn--icon"><i class="fas fa-pen"></i></button></td>
                                                        <td data-label="Delete"><button class="btn btn--danger btn--icon remove-item"><i class="fas fa-trash"></i></button></td>
                                                    </tr>
                                                    <tr>
                                                        <td data-label="Language">Filipino</td>
                                                        <td data-label="Sentence">Lorem ipsum dolor sit amet</td>
                                                        <td data-label="Language">Cebuano</td>
                                                        <td data-label="Sentence">Lorem ipsum dolor sit amet</td>
                                                        <td data-label="Staff">Admin1</td>
                                                        <td data-label="Edit"><button class="btn btn--warning btn--icon"><i class="fas fa-pen"></i></button></td>
                                                        <td data-label="Delete"><button class="btn btn--danger btn--icon remove-item"><i class="fas fa-trash"></i></button></td>
                                                    </tr>
                                                    <tr>
                                                        <td data-label="Language">Filipino</td>
                                                        <td data-label="Sentence">Lorem ipsum dolor sit amet</td>
                                                        <td data-label="Language">Cebuano</td>
                                                        <td data-label="Sentence">Lorem ipsum dolor sit amet</td>
                                                        <td data-label="Staff">Admin1</td>
                                                        <td data-label="Edit"><button class="btn btn--warning btn--icon"><i class="fas fa-pen"></i></button></td>
                                                        <td data-label="Delete"><button class="btn btn--danger btn--icon remove-item"><i class="fas fa-trash"></i></button></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal fade" id="addRepositoryModal" tabindex="-1" aria-labelledby="addRepositoryModal" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered modal-md">
                    <div class="modal-content border-0">
                        <div class="modal-body">
                            <form action="">
                                <h4 class="title mb-4 pb-lg-2">Add Repository</h4>
                                <input type="text" class="form-control form--control mb-3" placeholder="Domain Name" />
                                <textarea name="" id="" cols="30" rows="10" class="form-control form--control" placeholder="Description"></textarea>
                                <div class="d-flex flex-wrap justify-content-end mt-4">
                                    <button type="submit" class="btn btn--success">Add</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}